<template lang="pug">
div
  #regModal.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered
      .modal-content
        .position-absolute.close-button.pointer(@click="$helpers.closeModal('#regModal')")
          i.fa-solid.fa-x.fa-2x
        //- img(src='assets/img/register.jpg')
        img(src='assets/img/login-banner.jpg')
        .modal-header-cus
          //- img(src='assets/img/logo.png')
          h2 {{$t('ui.register')}}
        form
          .modal-body
            .mb-2
              input.form-control#signUpUsername(type='text' autocomplete="off" v-model.trim="$v.signUpUsername.$model" :placeholder="$t('ui.username')" @keyup.enter="signUp" maxlength="20")
            validation.mb-2(:value="$v.signUpUsername" :name="$t('ui.username')" target="REGISTERNAME")
            .mb-2
              input.form-control(type='password' autocomplete="off" v-model.trim="$v.signUpPassword.$model" @keyup.enter="signUp" :placeholder="$t('ui.password')" maxlength="20")
            validation.mb-2(:value="$v.signUpPassword" :name="$t('ui.password')" target="REGISTERPW")
            .mb-2.d-flex.justify-content-between
              .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.prefix +63
              input.form-control(type='text' :placeholder="$t('ui.phone_number')" minLength="10" maxlength="10" v-model.trim="$v.registerNo.$model" @keypress="$helpers.onlyNumber" @keyup.enter="signUp")
            validation.mb-2(:value="$v.registerNo" :name="$t('ui.phone_number')" target="REGISTERNO")
            //- .mb-2
              input.form-control(type='password' :placeholder="$t('ui.confirm_password')")
            .mb-2
              input.form-control(type='text' :placeholder="$t('ui.email')+'('+$t('ui.optional')+')'" v-model.trim="$v.userEmail.$model"  @keyup.enter="signUp")
            validation.mb-2(:value="$v.userEmail" :name="$t('ui.email')" target="REGISTEREMAIL")
            .mb-2 
              input.form-control(type='text' :placeholder="$t('ui.referral_code')+'('+$t('ui.optional')+')'" v-model="referralCode" @keypress="$helpers.onlyAlphaNum" @keyup.enter="signUp" :disabled="disabledRef")
          .modal-footer.s2
            .text-center
              button.btn-submit(type="button" @click.stop="signUp") {{$t('ui.register')}}
            .text-center.mt-3
              a.modal-link(href='#' data-bs-toggle='modal' data-bs-target='#logModal') {{$t('ui.signupform.account_exist')}}
                b {{$t('ui.login')}}
  #regModal2.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered
      .modal-content
        //- img(src='assets/img/register.jpg')
        img(src='assets/img/login-banner.jpg')
        .modal-header-cus
          //- img(src='assets/img/logo.png')
          h2 {{$t('ui.register')}}
        form
          .verification.p-3.mb-1
            .text-capitalize.text-center.mb-3.text-verify {{ $t("ui.verification_number") }}
            .text-center.mb-2(v-if="tacCountDown") {{ $t("message.tac_tooltips") }}
            .d-flex.justify-content-between.px-1
              .input-group
                input.form-control.text-center(type='text' autocomplete="off" :placeholder="$t('ui.tac_code')"  v-model.trim="$v.tacCode.$model" @keypress="$helpers.onlyNumber")
                .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.disabled-grey(v-if="tacCountDown")
                  | {{ tacDisplay }}
                .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center(v-else @click="resendTacCode")
                  | {{ $t("ui.resend") }}
          .modal-footer.s2
            .text-center
              button.btn-submit(type="button" @click.stop="tacValidate") {{$t('ui.next')}}
          //- a(href="javascript:void(0);" @click.stop="tacValidate" :disabled="loading")
          //-   .btn.btn-block.btn-main.btn-purple  {{ $t("ui.next") }}
        .font-weight-bold.text-danger.mt-3.p-2 {{$tc('ui.tac_tips')}}
        div.modal-livechat-btn.livechat_button(@click="openChat")
          img(src="assets/img/livechat.png")
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  email
} from "vuelidate/lib/validators";
import validation from "@/library/_validation.vue";
import _ from "lodash";
export default {
  components: {
    validation
  },
  data() {
    return {
      signUpUsername: "",
      signUpPassword: "",
      registerNo: "",
      referralCode: "",
      affiliateCode: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      conditionChecked: false,
      isTacPanel: false,
      tacCode: "",
      disabledRef: false,
      disabledAffi: false,
      tacTimer: null,
      tacCountDown: false,
      tacDisplay: "",
      ch: "",
      cm: "",
      pp: "",
      userEmail: "",
      globeArray: [
        "http://www.epic888.asia/",
        "http://www.epic888.cc/",
        "http://www.epic888.co/",
        "http://www.epic888.net/",
        "https://www.epic888.asia/",
        "https://www.epic888.cc/",
        "https://www.epic888.co/",
        "https://www.epic888.net/"
      ],
      smartArray: [
        "http://www.epic8888.asia/",
        "http://www.epic8888.cc/",
        "http://www.epic8888.co/",
        "http://www.epic8888.com/",
        "https://www.epic8888.asia/",
        "https://www.epic8888.cc/",
        "https://www.epic8888.co/",
        "https://www.epic8888.com/"
      ],
      jimMy: [
        "http://epicwinfree8.com/",
        "http://www.epicwinfree8.com/",
        "https://epicwinfree8.com/",
        "https://www.epicwinfree8.com/"
      ],
      app88: [
        "http://epwin10.com/",
        "https://epwin10.com/",
        "http://www.epwin10.com/",
        "https://www.epwin10.com/"
      ],
      app2: [
        "http://epwin8.com/",
        "https://epwin8.com/",
        "http://www.epwin8.com/",
        "https://www.epwin8.com/"
      ],
      app3: [
        "http://epwin11.com/",
        "https://epwin11.com/",
        "http://www.epwin11.com/",
        "https://www.epwin11.com/"
      ],
      app4: [
        "http://epwin12.com/",
        "https://epwin12.com/",
        "http://www.epwin12.com/",
        "https://www.epwin12.com/"
      ],
      app5: [
        "http://epwin13.com/",
        "https://epwin13.com/",
        "http://www.epwin13.com/",
        "https://www.epwin13.com/"
      ],
      app6: [
        "http://epwin14.com/",
        "https://epwin14.com/",
        "http://www.epwin14.com/",
        "https://www.epwin14.com/"
      ],
      app7: [
        "http://epwin15.com/",
        "https://epwin15.com/",
        "http://www.epwin15.com/",
        "https://www.epwin15.com/"
      ],
      globe1: [
        "http://epwin16.com/",
        "https://epwin16.com/",
        "http://www.epwin16.com/",
        "https://www.epwin16.com/"
      ],
      globe2: [
        "http://epwin17.com/",
        "https://epwin17.com/",
        "http://www.epwin17.com/",
        "https://www.epwin17.com/"
      ],
      globe3: [
        "http://epwin18.com/",
        "https://epwin18.com/",
        "http://www.epwin18.com/",
        "https://www.epwin18.com/"
      ],
      globe4: [
        "http://epwin19.com/",
        "https://epwin19.com/",
        "http://www.epwin19.com/",
        "https://www.epwin19.com/"
        // "http://эпвин.рус/",
        // "https://эпвин.рус/",
        // "http://www.эпвин.рус/",
        // "https://www.эпвин.рус/",
        // "https://xn--b1ampf3e.xn--p1acf/",
        // "http://xn--b1ampf3e.xn--p1acf/",
      ],
      // affiBlack:[
      //   "http://epicwin66.com/",
      //   "https://epicwin66.com/",
      //   "http://www.epicwin66.com/",
      //   "https://www.epicwin66.com/"
      // ],
      adsss:[
        "http://epicwinph.xyz/",
        "https://epicwinph.xyz/",
        "http://www.epicwinph.xyz/",
        "https://www.epicwinph.xyz/"
      ],
      pin:[
        "http://epicphjili.xyz/",
        "https://epicphjili.xyz/",
        "http://www.epicphjili.xyz/",
        "https://www.epicphjili.xyz/"
      ],
      bio:[
        "http://epicwin.fun/",
        "https://epicwin.fun/",
        "http://www.epicwin.fun/",
        "https://www.epicwin.fun/"
      ],
      tips:[
        "http://epicwin8.club/",
        "https://epicwin8.club/",
        "http://www.epicwin8.club/",
        "https://www.epicwin8.club/"
      ],
      bb3:[
        "http://epicwinph.site/",
        "https://epicwinph.site/",
        "http://www.epicwinph.site/",
        "https://www.epicwinph.site/"
      ],
      blogg:[
        "http://epicwinph.live/",
        "https://epicwinph.live/",
        "http://www.epicwinph.live/",
        "https://www.epicwinph.live/"
      ],
      slots:[
        "http://epicphjili.site/",
        "https://epicphjili.site/",
        "http://www.epicphjili.site/",
        "https://www.epicphjili.site/"
      ],
      facebooks:[
        "http://epicwin8.xyz/",
        "https://epicwin8.xyz/",
        "http://www.epicwin8.xyz/",
        "https://www.epicwin8.xyz/"
      ],
      hdmovie:[
        "http://epicwin8.info/",
        "https://epicwin8.info/",
        "http://www.epicwin8.info/",
        "https://www.epicwin8.info/"
      ],
      john1:[
        "http://epicwin8.site/",
        "https://epicwin8.site/",
        "http://www.epicwin8.site/",
        "https://www.epicwin8.site/"
      ],
      annah:[
        "http://epicwin8.fun/",
        "https://epicwin8.fun/",
        "http://www.epicwin8.fun/",
        "https://www.epicwin8.fun/"
      ],
      marjz:[
        "http://epicwinph.asia/",
        "https://epicwinph.asia/",
        "http://www.epicwinph.asia/",
        "https://www.epicwinph.asia/"
      ],
      shuriken:[
        "http://epicwinph.online/",
        "https://epicwinph.online/",
        "http://www.epicwinph.online/",
        "https://www.epicwinph.online/"
      ],
      tengsss:[
        "http://epicwin66.com/",
        "https://epicwin66.com/",
        "http://www.epicwin66.com/",
        "https://www.epicwin66.com/"
      ],
      moneymeme:[
        "http://epicwinph.website/",
        "https://epicwinph.website/",
        "http://www.epicwinph.website/",
        "https://www.epicwinph.website/"
      ],
      globee:[
        "http://epwin2.com/",
        "https://epwin2.com/",
        "http://www.epwin2.com/",
        "https://www.epwin2.com/"
      ],
      ee6688:[
        "http://epicwinvip.site/",
        "https://epicwinvip.site/",
        "http://www.epicwinvip.site/",
        "https://www.epicwinvip.site/"
      ],
      regina:[
        "http://epicwinjili.online/",
        "https://epicwinjili.online/",
        "http://www.epicwinjili.online/",
        "https://www.epicwinjili.online/"
      ],
      youtube:[
        "http://epicwinjili.site/",
        "https://epicwinjili.site/",
        "http://www.epicwinjili.site/",
        "https://www.epicwinjili.site/"
      ],
      instagram33:[
        "http://epicphwin.com/",
        "https://epicphwin.com/",
        "http://www.epicphwin.com/",
        "https://www.epicphwin.com/"
      ],
      showSmartico: false
      // emailChecked: false,
    };
  },
  computed: {
    getAnnAfterLog() {
      return this.$store.state.user.annAfterLog;
    },
    getLanguage() {
      return this.$store.getters.language || "en";
    }
  },
  validations: {
    signUpUsername: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      valid: function(value) {
        const containsAlphabet = /[A-Za-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        return containsAlphabet || containsNumber;
      }
    },
    signUpPassword: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      valid: function(value) {
        const containsAlphabet = /[A-Za-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        return containsAlphabet && containsNumber;
      }
    },
    registerNo: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
    userEmail:{
      email
    },
    tacCode: {
      required(val) {
        return this.isTacPanel ? required(val) : true;
      }
    }
  },
  created() {
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.tut) {
        this.showSmartico = true;
      }
    }
  },
  mounted() {
    this.checkDomain();
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.ref) {
        this.referralCode = this.$route.query.ref;
        this.disabledRef = true;
      }
      if (this.$route.query.affiliatecode) {
        this.affiliateCode = this.$route.query.affiliatecode;
        this.disabledAffi = true;
      }
      if (this.$route.query.ch) {
        this.ch = this.$route.query.ch;
      }
      if (this.$route.query.cm) {
        this.cm = this.$route.query.cm;
      }
      if (this.$route.query.pp) {
        this.pp = this.$route.query.pp;
      }
      // this.$router.replace('/')
      $("#regModal").modal("show");
    }
    $("#regModal").on("shown.bs.modal", function() {
      $("#signUpUsername").trigger("focus");
    });
    $("#regModal").on("hidden.bs.modal", function() {
      $("#signUpUsername").trigger("focus");
      this.disabledRef = false;
      this.disabledAffi = false;
    });
    var vm = this;
    $("#regModal2").on("hidden.bs.modal", function() {
      vm.clearCountDown();
      vm.tacCountDown = false;
      // vm.reset();
    });
  },
  methods: {
    checkDomain() {
      var site =
        window.location.protocol + "//" + window.location.hostname + "/";
      if (this.globeArray.includes(site)) {
        this.affiliateCode = "ELIGLOBE";
      }
      if (this.smartArray.includes(site)) {
        this.affiliateCode = "ELISMART";
      }
      if (this.jimMy.includes(site)) {
        this.affiliateCode = "JIMMY";
      }
      if (this.app88.includes(site)) {
        this.affiliateCode = "APP88";
      }
      if (this.app2.includes(site)) {
        this.affiliateCode = "APP2";
      }
      if (this.app3.includes(site)) {
        this.affiliateCode = "APP3";
      }
      if (this.app4.includes(site)) {
        this.affiliateCode = "APP4";
      }
      if (this.app5.includes(site)) {
        this.affiliateCode = "APP5";
      }
      if (this.app6.includes(site)) {
        this.affiliateCode = "APP6";
      }
      if (this.app7.includes(site)) {
        this.affiliateCode = "APP7";
      }
      if (this.globe1.includes(site)) {
        this.affiliateCode = "GLOBE1";
      }
      if (this.globe2.includes(site)) {
        this.affiliateCode = "GLOBE2";
      }
      if (this.globe3.includes(site)) {
        this.affiliateCode = "GLOBE3";
      }
      if (this.globe4.includes(site)) {
        this.affiliateCode = "GLOBE4";
      }
      // if (this.affiBlack.includes(site)) {
      //   this.affiliateCode = "BLACK";
      // }
      if (this.adsss.includes(site)) {
        this.affiliateCode = "ADSSS";
      }
      if (this.pin.includes(site)) {
        this.affiliateCode = "PIN";
      }
      if (this.bio.includes(site)) {
        this.affiliateCode = "BIO";
      }
      if (this.tips.includes(site)) {
        this.affiliateCode = "TIPS";
      }
      if (this.bb3.includes(site)) {
        this.affiliateCode = "BB3";
      }
      if (this.blogg.includes(site)) {
        this.affiliateCode = "BLOGG";
      }
      if (this.slots.includes(site)) {
        this.affiliateCode = "SLOTS";
      }
      if (this.facebooks.includes(site)) {
        this.affiliateCode = "FACEBOOKS";
      }
      if (this.hdmovie.includes(site)) {
        this.affiliateCode = "HDMOVIE";
      }
      if (this.john1.includes(site)) {
        this.affiliateCode = "JOHN1";
      }
      if (this.annah.includes(site)) {
        this.affiliateCode = "ANNAH";
      }
      if (this.marjz.includes(site)) {
        this.affiliateCode = "MARJZ";
      }
      if (this.shuriken.includes(site)) {
        this.affiliateCode = "SHURIKEN";
      }
      if (this.tengsss.includes(site)) {
        this.affiliateCode = "TENGSSS";
      }
      if (this.moneymeme.includes(site)) {
        this.affiliateCode = "MONEYMEME";
      }
      if (this.globee.includes(site)) {
        this.affiliateCode = "GLOBEE";
      }
      if (this.ee6688.includes(site)) {
        this.affiliateCode = "EE6688";
      }
      if (this.regina.includes(site)) {
        this.affiliateCode = "REGINA";
      }
      if (this.youtube.includes(site)) {
        this.affiliateCode = "YOUTUBE";
      }
      if (this.instagram33.includes(site)) {
        this.affiliateCode = "INSTAGRAM33";
      }
    },
    openChat() {
      LiveChatWidget.call("maximize");
    },
    toggleCheck() {
      this.emailChecked = !this.emailChecked;
      if (this.emailChecked == false) {
        this.userEmail = "";
      }
    },
    countDown() {
      var vm = this;
      var timer = 180000;
      this.tacCountDown = true;
      this.tacTimer = setInterval(() => {
        if (timer > 0) {
          timer -= 1000;
          this.tacDisplay = vm.$moment.utc(timer).format("mm:ss");
        } else {
          this.clearCountDown();
          vm.tacCountDown = false;
          this.tacDisplay = "";
        }
      }, 1000);
    },
    clearCountDown() {
      clearInterval(this.tacTimer);
    },
    getMobile() {
      let isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        }
      };

      if (isMobile.iOS()) {
        this.isIOS = true;
      } else {
        this.isIOS = false;
      }
    },
    signUp() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let account_id = this.signUpUsername;
        let password = this.signUpPassword;
        let contact_phone = this.registerNo;
        let referral_code = this.referralCode;
        let affiliate_code = this.affiliateCode;
        let contact_email = this.userEmail;
        let ch = this.ch;
        let cm = this.cm;
        let pp = this.pp;
        let domain = window.location.protocol + "//" +window.location.hostname
        if (localStorage.getItem("fbp") === null) {
          var fbp = null;
        } else {
          var fbp = localStorage.getItem("fbp");
        }
        if (localStorage.getItem("pixelId") === null) {
          var pixelId = null;
        } else {
          var pixelId = localStorage.getItem("pixelId");
        }
        this.loading = true;
        this.$store
          .dispatch("user/memberSignUp", {
            account_id,
            password,
            contact_phone,
            referral_code,
            affiliate_code,
            ch,
            cm,
            pp,
            fbp,
            pixelId,
            domain,
            contact_email
          })
          .then(response => {
            this.loading = false;
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              this.countDown();
              $("#regModal").modal("hide");
              $("#regModal2").modal("show");
              // this.isTacPanel = true
              // this.$store.dispatch("user/updatePanel", true);
            } else {
              // this.isTacPanel = false
              // this.$store.dispatch("user/updatePanel", false);
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
              // this.signUpLog(false, this.$t("message.list." + response.status))
            }
          })
          .catch(response => {
            this.loading = false;
            // this.isTacPanel = false
            // this.$store.dispatch("user/updatePanel", false);
            this.feedback.success = false;
            this.$helpers.showDialog(
              this.$t("ui.attention"),
              this.$t("message.list." + response.status),
              "info",
              this
            );
            // this.signUpLog(false, this.$t("message.list." + response.status))
            this.feedback.status = this.$t("error." + response.status);
          });
      }
    },
    tacValidate() {
      this.$v.$touch();
      if (!this.$v.tacCode.$invalid) {
        if (this.$store.state.user.tempName !== "") {
          var account_id = this.$store.state.user.tempName;
        } else {
          var account_id = this.signUpUsername;
        }
        let tac = this.tacCode;
        let referral_code = this.referralCode;
        // let contact_email = this.userEmail;
        this.loading = true;
        this.$store
          .dispatch("user/memberTacValidate", {
            account_id,
            tac,
            referral_code,
            // contact_email
          })
          .then(response => {
            this.loading = false;
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              this.clearCountDown();
              $("#regModal2").modal("hide");
              this.login();
              // this.reset();
            } else {
              if (typeof response.status != "object") {
                this.$helpers.showDialog(
                  this.$t("ui.attention"),
                  this.$t("message.list." + response.status),
                  "info",
                  this
                );
              }
              // this.signUpLog(false, this.$t("message.list." + response.status))
            }
          })
          .catch(response => {
            if (response.status === "tac_expired") {
              this.clearCountDown();
              this.tacCountDown = false;
              this.tacCode = "";
            }
            this.loading = false;
            this.feedback.success = false;
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
            }
            this.feedback.status = this.$t("error." + response.status);
            // this.signUpLog(false, this.$t("message.list." + response.status))
          });
      }
    },
    resendTacCode() {
      // this.countDown();
      if (this.$store.state.user.tempName !== "") {
        var account_id = this.$store.state.user.tempName;
      } else {
        var account_id = this.signUpUsername;
      }

      this.loading = true;
      this.$store
        .dispatch("user/memberRenewTac", { account_id })
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success;
          this.feedback.status = response.status;
          if (this.feedback.success == true) {
            this.$helpers.showDialog(
              "success",
              this.$t("ui.tac_code_new"),
              "success",
              this
            );
            this.countDown();
          } else {
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
            }
          }
        })
        .catch(response => {
          this.loading = false;
          this.feedback.success = false;
          if (typeof response.status != "object") {
            this.$helpers.showDialog(
              this.$t("ui.attention"),
              this.$t("message.list." + response.status),
              "info",
              this
            );
          }
          this.feedback.status = this.$t("error." + response.status);
        });
    },
    login() {
      if (this.$store.state.user.tempName !== "") {
        var vm = this;
        // if(this.$store.state.user.tempPass === ""){
        //   this.$swal({
        //     title: vm.$tc("ui.attention"),
        //     text: vm.$tc("ui.success"),
        //     type: "success"
        //   }).then(result => {
        //     $('#regModal2').modal('hide')
        //     $('#logModal').modal('show')
        //   });
        //   return
        // }else{
        var username = this.$store.state.user.tempName;
        var password = this.$store.state.user.tempPass;
        var path = "user/login";
        var data = {
          username,
          password
        };
        // }
      } else {
        var username = this.signUpUsername;
        var password = this.signUpPassword;
        var path = "user/login";
        var data = {
          username,
          password
        };
      }

      this.loading = true;
      this.$store
        .dispatch(path, data)
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success;
          if (this.feedback.success == true) {
            this.$store.dispatch("user/tempAccName", "");
            this.$store.dispatch("user/tempPass", "");
            window._smartico_user_id = this.$store.getters.accountID;
            window._smartico_language = this.getLanguage;
            if (this.showSmartico === true) {
              _smartico.dp("dp:gf");
            } else {
              if (this.getAnnAfterLog.length > 0) {
                $("#annModal").modal("show");
              }
            }
          } else {
            var vm = this;
            if (response.status) {
              this.feedback.status = this.$tc(
                "message.list." + response.status
              );
            }
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                vm.$tc("ui.attention"),
                vm.$tc("message.list." + response.status),
                "info",
                this
              );
            }
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;

          this.feedback.success = response.success;
          var vm = this;
          if (response.status) {
            this.feedback.status = this.$tc("message.list." + response.status);
          }
          if (typeof response.status != "object") {
            this.$helpers.showDialog(
              vm.$tc("ui.attention"),
              vm.$tc("message.list." + response.status),
              "info",
              this
            );
          }
        });
    },
    reset() {
      this.$store.dispatch("user/tempAccName", "");
      this.$store.dispatch("user/tempPass", "");
      this.clearCountDown();
      this.tacCountDown = false;
      this.tacCode = "";
      this.signUpUsername = "";
      this.signUpPassword = "";
      this.registerNo = "";
      this.$v.$reset();
    }
  }
};
</script>
<style lang="scss" scoped>
.prefix {
  width: 80px;
  cursor: default;
}
</style>
  